import { observable } from 'mobx';
import { useEffect } from 'react';
import { jumpPage } from '@src/utils/common-util';
import toWebpImage from '@src/utils/to-webp-image';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';

class mechaUnitPageStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  // 是否激活
  @observable isActive = false;
  @observable tabIndex = 0;
  @observable mechaList = [];

  mechaUnitSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      spaceBetween: 0,
      autoplay: {
        disableOnInteraction: false,
        delay: 5000
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 500
    }
  });

  gounit(id) {
    if (!IS_DEV_ENV) {
      const url = 'mecha-unit.html';
      jumpPage(url, `?id=${id}`);
    } else {
      this.mainStore?.redirect(`/mecha-unit?id=${id}`);
    }
  }
  use() {
    const funlinkData = useLayerData('mechaUnitData');
    useEffect(
      () => {
        if (funlinkData) {
          this.mechaList = funlinkData?.mechaList || [];
          // console.log([...this.mechaList]);
          
        }
      },
      [funlinkData]
    );
    useEffect(
      () => {
        const indicatorBox = document.querySelector('.indicatorBoxs');
        this.tabIndex = this.mechaUnitSwiper.activeIndex;
       if (this.tabIndex === 2) {
          indicatorBox.scrollLeft = '98';
        } else if (this.tabIndex > 2) {
          indicatorBox.scrollLeft = '196';
        } else {
          indicatorBox.scrollLeft = '0';
        }
      },
      [this.mechaUnitSwiper.activeIndex]
    );
  }
}

export default mechaUnitPageStore;
